import { ref } from 'vue'
import { defineStore } from 'pinia'
import { getInfo } from '@/api'

export const useUserStore = defineStore('user', () => {
  const isLogin = ref(false)
  const info = ref<any>({})
  const showLogin = ref(false)

  const setIsLogin = (bol: boolean) => {
    isLogin.value = bol

    if (!bol) {
      info.value = {}
    }
  }

  const setInfo = () => {
    getInfo().then(res => {
      info.value = res.data
      isLogin.value = true
    })

  }

  const setShowLogin = (bol: boolean) => {
    showLogin.value = bol
  }

  return { isLogin, setIsLogin, info, setInfo, setShowLogin, showLogin }
})
